import { useRef, useCallback } from "react";
function useFocus({
  onBlur,
  onFocus
}) {
  const containerRef = useRef(null);
  const isFocused = useRef(false);
  const handleBlur = useCallback(
    (event) => {
      const clickedOnNonFocusableElement = !event.relatedTarget;
      if (clickedOnNonFocusableElement) {
        isFocused.current = false;
        onBlur?.(event);
        return;
      }
      const element = containerRef.current;
      if (!element) {
        isFocused.current = false;
        onBlur?.(event);
        return;
      }
      const clickedOutside = !element.contains(event.relatedTarget);
      if (clickedOutside) {
        isFocused.current = false;
        onBlur?.(event);
        return;
      }
    },
    [onBlur]
  );
  const handleFocus = useCallback(
    (event) => {
      if (isFocused.current) {
        return;
      }
      isFocused.current = true;
      onFocus?.(event);
    },
    [onFocus]
  );
  return { handleFocus, handleBlur, containerRef };
}
export {
  useFocus
};
//# sourceMappingURL=use-focus.js.map
